import { SUPPORTED_LANGUAGES, SupportedLanguage, TranslationConfig } from "../models/language";



export function getSupportedLanguage(field: string, value: string): SupportedLanguage | null {
    const matchingLanguage = SUPPORTED_LANGUAGES.find((languageObject:SupportedLanguage):boolean => {
        return languageObject[field] === value;
    });

    return matchingLanguage || null;
    }

export async function translateText(translateUrl: string, textToTranslate: string, translationConfig: TranslationConfig): Promise<any> {
    console.log('translateText textToTranslateV3:', textToTranslate);
    console.log('translateText languageToTranslateToV3:', translationConfig.targetLanguage);
    console.log('translateText languageToTranslateFromV3:', translationConfig.sourceLanguage);
    try {
        const response = await fetch(`${translateUrl}/eptcct-google-translate/api/googletranslate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                text: textToTranslate,
                ...translationConfig
            })
        });
        const data = await response.json();
        console.log('translateText v3 response:', data);
        return data.translation;
    } catch (error) {
        console.error('Error translating text v3:', error);
        return null;
    }
}